import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

UIkit.use(Icons);

window.addEventListener('load', init);
function init() {
    let boxReloadLink = document.querySelector('.consent_manager-show-box-reload');

    if (boxReloadLink) {
        boxReloadLink.addEventListener('click', () => {
            consent_manager_parameters.forcereload = 1;
            consent_manager_showBox();
        })
    }
}

function hideOffcanvas() {
    UIkit.offcanvas('.mobile-navigation').hide();
}
